export default [{name: '-configuracoes',
path: '/-configuracoes',
props: true,
component: () => import('/pages/-configuracoes.vue')},
{path: '/contagens',
props: true,
component: () => import('/pages/contagens.vue'),
children: [
      {name: 'contagens',
path: '',
props: true,
component: () => import('/pages/contagens/index.vue')},{name: 'contagens-uuid',
path: ':uuid',
props: true,
component: () => import('/pages/contagens/[uuid]/index.vue')},

    ]},
{name: 'index',
path: '/',
props: true,
component: () => import('/pages/index.vue')},
{path: '/login',
props: true,
component: () => import('/pages/login.vue'),
children: [
      {name: 'login',
path: '',
props: true,
component: () => import('/pages/login/index.vue')},{name: 'login-recover',
path: 'recover',
props: true,
component: () => import('/pages/login/recover.vue')},

    ]},
{path: '/lojas',
props: true,
component: () => import('/pages/lojas.vue'),
children: [
      {name: 'lojas',
path: '',
props: true,
component: () => import('/pages/lojas/index.vue')},{name: 'lojas-novo',
path: 'novo',
props: true,
component: () => import('/pages/lojas/novo.js')},{name: 'lojas-editar-uuid',
path: 'editar/:uuid',
props: true,
component: () => import('/pages/lojas/editar/[uuid].vue')},

    ]},
{path: '/produtos',
props: true,
component: () => import('/pages/produtos.vue'),
children: [
      {name: 'produtos',
path: '',
props: true,
component: () => import('/pages/produtos/index.vue')},{name: 'produtos-novo',
path: 'novo',
props: true,
component: () => import('/pages/produtos/novo.js')},{name: 'produtos-editar-uuid',
path: 'editar/:uuid',
props: true,
component: () => import('/pages/produtos/editar/[uuid].vue')},

    ]},
{path: '/usuarios',
props: true,
component: () => import('/pages/usuarios.vue'),
children: [
      {name: 'usuarios',
path: '',
props: true,
component: () => import('/pages/usuarios/index.vue')},{name: 'usuarios-novo',
path: 'novo',
props: true,
component: () => import('/pages/usuarios/novo.js')},{name: 'usuarios-editar-uuid',
path: 'editar/:uuid',
props: true,
component: () => import('/pages/usuarios/editar/[uuid].vue')},

    ]},
{path: '/configuracoes/arquivos',
props: true,
component: () => import('/pages/configuracoes/arquivos.vue'),
children: [
      {name: 'configuracoes-arquivos',
path: '',
props: true,
component: () => import('/pages/configuracoes/arquivos/index.vue')},{name: 'configuracoes-arquivos-novo',
path: 'novo',
props: true,
component: () => import('/pages/configuracoes/arquivos/novo.vue')},

    ]},
{name: 'configuracoes',
path: '/configuracoes',
props: true,
component: () => import('/pages/configuracoes/index.vue')}];